import type {
  CollaboratorAccrualsMapperT,
  GetCollaboratorAccrualsResponseT,
} from "../types/collaboratorAccruals.types";
import type { CollaboratorAccrualEntityT } from "../../domain/entities/collaboratorAccruals.entity";

import { displayToIsoDate } from "../../helpers/accrualDateFormat";

export const collaboratorAccrualsMapper: CollaboratorAccrualsMapperT = {
  collaboratorAccrualsDtoToDomain: (
    rawData: GetCollaboratorAccrualsResponseT,
  ): CollaboratorAccrualEntityT => ({
    collaboratorId: rawData?.data?.collaborator_id,
    vacationSourceStart: rawData?.data?.vacation_source_start ?? null,
    total: rawData?.data?.total ?? 0,
    accruals: rawData?.data?.accruals
      ? rawData.data.accruals.map((accrual) => ({
          id: accrual.id,
          collaboratorId: accrual.collaborator_id,
          accrualType: accrual.accrual_type,
          registrationDate: accrual.registration_date,
          vacationDays: accrual.vacation_days,
          primaDays: accrual.prima_days,
          primaPercentage: accrual.prima_percentage,
          isAnniversary: accrual.is_anniversary,
          isInitialBalance: accrual.is_initial_balance,
          expirationDate: accrual.expiration_date,
          description: accrual.description,
          parentId: accrual.parent_id,
          createdAt: accrual.created_at,
        }))
      : null,
  }),
  toDeleteDto: (accrualIds) => ({
    accruals: accrualIds,
  }),
  deleteDtoToDomain: (rawData) => {
    const result = rawData?.data;

    return {
      deleted: result?.deleted ?? 0,
      skipped: result?.skipped ?? 0,
      totalRequested: result?.total_requested ?? 0,
      message: result?.message ?? "",
      errors: (result?.errors ?? []).map((item) => ({
        accrualId: item.accrual_id,
        error: item.error,
      })),
    };
  },
  toUpdateDto: (accruals) => ({
    accruals: accruals.map((accrual) => ({
      id: accrual.id,
      description: accrual.description,
      is_initial_balance: accrual.isInitialBalance,
      prima_days: String(accrual.primaDays),
      prima_percentage: String(accrual.primaPercentage),
      registration_date: displayToIsoDate(accrual.registrationDate),
      vacation_days: String(accrual.vacationDays),
    })),
  }),
  updateDtoToDomain: (rawData) => {
    const result = rawData?.data;

    return {
      updated: result?.updated ?? 0,
      skipped: result?.skipped ?? 0,
      totalRequested: result?.total_requested ?? 0,
      message: result?.message ?? "",
      errors: (result?.errors ?? []).map((item) => ({
        accrualId: item.accrual_id,
        error: item.error,
      })),
    };
  },
};
